import { APIClient } from '../utils/APIClient';
import { API_URL } from '../settings/local_settings';

/**
 * Wrapper API para asignaciones de Sets de columnas al Tablero del Portal del Cliente (V2).
 *
 * Portal V2 refactor (2026-05-28): los sets son `UserDashboardColumnsSettings`
 * (Tablero general). El panel del cliente sólo asigna / desasigna — no crea ni edita.
 *
 * Endpoints documentados en `Dashbo-Backend/monitor_api/urls.py`.
 */
export const ClientDashboardColumnsSetsApi = {
    // Gestión agencia
    listAssignments(clientId) {
        return new APIClient(`${API_URL}client/${encodeURIComponent(clientId)}/dashboard-columns-sets/`)
            .call('GET');
    },

    assignSet(clientId, columnsSettingsId) {
        return new APIClient(`${API_URL}client/${encodeURIComponent(clientId)}/dashboard-columns-sets/`)
            .call('POST', { columns_settings_id: columnsSettingsId });
    },

    unassignSet(clientId, assignmentId) {
        return new APIClient(`${API_URL}client/${encodeURIComponent(clientId)}/dashboard-columns-sets/${assignmentId}/`)
            .call('DELETE');
    },

    reorderAssignments(clientId, orderedIds) {
        return new APIClient(`${API_URL}client/${encodeURIComponent(clientId)}/dashboard-columns-sets/reorder/`)
            .call('PATCH', { ordered_ids: orderedIds });
    },

    setMode(clientId, mode) {
        // mode: 'CARDS_V1' | 'TABLE_V2'
        return new APIClient(`${API_URL}client/${encodeURIComponent(clientId)}/portal-dashboard-mode/`)
            .call('PATCH', { mode });
    },

    // Catálogo de sets del agency user (Tablero general) — para el modal "Asignar set".
    listAgencyUserSets() {
        return new APIClient(`${API_URL}dashboard/columns-sets`).call('GET');
    },

    // Portal cliente (auth: user tipo Cliente con permiso dashboard). `clientId` = cliente
    // activo del portal (multi-cliente); sin él, el backend resuelve el único/primario.
    listMySets(clientId = null) {
        const suffix = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        return new APIClient(`${API_URL}portal/me/dashboard-columns-sets/${suffix}`).call('GET');
    },

    // Preview (agency user previewing como cliente)
    listPreviewSets(clientId) {
        return new APIClient(`${API_URL}portal/preview/${encodeURIComponent(clientId)}/dashboard-columns-sets/`)
            .call('GET');
    },
};
